import React from 'react'
import { Controller, FieldName, Control } from 'react-hook-form'
import { TextInput } from '../TextInput'

export type HfTextInputProps<TFormValues> = {
  error?: string,
  name: FieldName<TFormValues>,
  control: Control<TFormValues>,
  disabled?: boolean,
  maxLength?: number,
  readOnly?: boolean,
  inputStyle?: string,
  onBlur?: () => void,
  placeholder?: string,
  label?: string,
  outsideLabel?: boolean,
  errorMessage?: string,
  subtitle?: string,
  endAdornment?: React.ReactNode,
  startAdornment?: React.ReactNode,
  containerClassName?: string,
  multiline?: boolean,
  rows?: number,
  rowsMax?: number,
  shrink?: boolean,
  autoCapitalize?: string,
  inputMode?: 'none' | 'text' | 'search' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | undefined
}

export function HfTextInput<TFormValues> (props: React.PropsWithChildren<HfTextInputProps<TFormValues>>) {
  const {
    control, error, name, disabled, maxLength, placeholder, startAdornment,
    endAdornment, inputStyle, shrink, readOnly, onBlur: customOnBlur, inputMode,
    autoCapitalize, ...rest
  } = props
  return (
    <Controller
      control={control as any}
      name={name}
      render={({ field }) => (
        <TextInput
          {...rest}
          {...field}
          onBlur={customOnBlur ? customOnBlur : field.onBlur}
          value={disabled ? '' : field.value}
          onChange={(ev) => field.onChange(ev.target.value)}
          shrink={shrink}
          inputProps={{
            maxLength,
            placeholder,
            inputMode,
            autoCapitalize
          }}
          error={Boolean(error)}
          InputProps={{
            startAdornment,
            endAdornment,
            readOnly,
            classes: { input: inputStyle }
          }}
        />
      )}
    />
  )
}
